'use client'

import { MenuItem, type MenuItemProps } from 'react-aria-components/Menu'

import { css, cx } from '../../../../styled-system/css'

export function DropdownMenuLink({ className, ...props }: MenuItemProps) {
    return (
        <MenuItem
            {...props}
            className={cx(
                typeof className === 'string' ? className : undefined,
                css({
                    display: 'block',
                    width: 'full',
                    textAlign: 'start',
                    paddingX: '4',
                    paddingY: '1',
                    fontSize: '[14px]',
                    lineHeight: 'none',
                    color: 'neutral.600',
                    whiteSpace: 'nowrap',
                    cursor: 'pointer',
                    _hover: {
                        color: 'info',
                        textDecoration: 'underline',
                    },
                    _focus: {
                        outline: 'none',
                        color: 'info',
                        textDecoration: 'underline',
                    },
                })
            )}
        />
    )
}
